var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "scan-menu-full-screen-modal",
      attrs: {
        id: "create-saved-search-modal",
        "cancel-title": _vm.$t("Cancel"),
        "ok-title": _vm.$t("saved.search.l.create"),
        centered: "",
        "header-class": "create-saved-search-modal-header",
        "ok-variant": "primary"
      },
      on: { ok: _vm.onValidateClicked },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "div",
                {
                  staticClass:
                    "create-saved-search-modal-header-content step4 w-100"
                },
                [
                  _c("img", {
                    staticClass: "create-saved-search-modal-img",
                    attrs: {
                      src: require("@/assets/images/b122/img-watcher-right.png")
                    }
                  })
                ]
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c("h4", { staticClass: "page-title" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("saved.search.create.title")) + "\n  ")
      ]),
      _vm._v(" "),
      _c("p", {
        staticClass: "mt-3 mb-3 content",
        domProps: {
          innerHTML: _vm._s(
            _vm.$t("saved.search.create.with.filters", {
              filters: this.filtersName
            })
          )
        }
      }),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          staticClass: "small-text",
          attrs: {
            "invalid-feedback": _vm.alertName.invalidFeedback,
            label: "Nom",
            "label-for": "identifier-input"
          }
        },
        [
          _c("b-form-input", {
            attrs: {
              id: "identifier-input",
              placeholder: _vm.$t("saved.search.create.placeholder"),
              state: _vm.alertName.state,
              required: ""
            },
            on: {
              change: function($event) {
                _vm.alertName.state = null
              }
            },
            model: {
              value: _vm.alertName.value,
              callback: function($$v) {
                _vm.$set(_vm.alertName, "value", $$v)
              },
              expression: "alertName.value"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43b36b92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43b36b92","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/search/CreateSavedSearchModal.vue
// module id = RzdY
// module chunks = 0